"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queueRequests = exports.isFulfilled = exports.isRejected = void 0;
const isRejected = (input) => input.status === 'rejected';
exports.isRejected = isRejected;
const isFulfilled = (input) => input.status === 'fulfilled';
exports.isFulfilled = isFulfilled;
async function queueRequests(data, fn, { groupSize, isParallel = false }) {
    const result = [];
    for (let i = 0; i < data.length; i += groupSize) {
        const group = data.slice(i, i + groupSize);
        const groupResult = isParallel ? fn(group) : await fn(group);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        result.push(groupResult);
    }
    return (await Promise.all(result)).flat();
}
exports.queueRequests = queueRequests;
//# sourceMappingURL=index.js.map